// extracted by mini-css-extract-plugin
module.exports =  {"checkbox":"campaignModalSenderAddress__checkbox"};